import React, { useState, useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query';

import useMutate from '../../../../hooks/useMutate';
import { changeStatusTodo } from '../../../../services/apiTodo';
import GredCheck from "../../../../styles/svg/gred-check.svg";
import GreenCheck from "../../../../styles/svg/green-check.svg";
import MarkAsCompleted from '../../../../components/ToDo/MarkAsCompleted';
import useBoardIdByKey from '../../../../hooks/useBoardIdByKey';

const TodoChangeStatus = React.memo(({
  status,
  cardId,
  boardId,
  checkOwnerOrAdmin,
  isAssignee,
  creator,
  reporterId,
  assignedUserId,
}) => {
  const queryClient = useQueryClient();
  const [isHoveredCompleted, setIsHoveredCompleted] = useState(false);
  const [isHoveredAccepted, setIsHoveredAccepted] = useState(false);
  const [isHoveredReOpen, setIsHoveredReOpen] = useState(false);
  const {id} = useBoardIdByKey();

  const { mutate, isPending } = useMutate(
    changeStatusTodo,
    ["mineCards"],
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, id],
      });
    }
  );
  //changeStatusTodo
  const changeStatus = useCallback((newStatus) => {
    mutate({ card_id: cardId, todo_column: newStatus });
  }, [mutate, cardId]);

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {status === "Open" && (checkOwnerOrAdmin || isAssignee || creator) && (
        <MarkAsCompleted
          changeStatus={changeStatus}
          loading={isPending}
          assignedUserId={assignedUserId}
          assignObject={{
            card_id: cardId,
            data: { assigned_to_user_id: reporterId },
          }}
        />
      )}

      {status === "Completed" && (
        <div className=" ml-1">
          {(checkOwnerOrAdmin || creator || isAssignee) && (
            <img
              className="cursor-pointer"
              src={isHoveredReOpen ? GredCheck : GreenCheck}
              onMouseEnter={() => setIsHoveredReOpen(true)}
              onMouseLeave={() => setIsHoveredReOpen(false)}
              onClick={(event) => {
                event.stopPropagation();
                changeStatus("Open");
              }}
              alt="reopen-task"
            />
          )}
          {(checkOwnerOrAdmin || creator) && (
            <img
              className="cursor-pointer"
              style={{ marginLeft: "-6px" }}
              src={isHoveredCompleted ? GreenCheck : GredCheck}
              onMouseEnter={() => setIsHoveredCompleted(true)}
              onMouseLeave={() => setIsHoveredCompleted(false)}
              onClick={(event) => {
                event.stopPropagation();
                changeStatus("Accepted");
              }}
              alt="mark-as-accepted"
            />
          )}
        </div>
      )}
      {status === "Accepted" && (checkOwnerOrAdmin || creator) && (
        <div
          className=" ml-1"
          onClick={(event) => {
            event.stopPropagation();
            changeStatus("Completed");
          }}
          onMouseEnter={() => setIsHoveredAccepted(true)}
          onMouseLeave={() => setIsHoveredAccepted(false)}
        >
          <img
            className="cursor-pointer"
            src={GreenCheck}
            alt="back-to-completed"
          />
          <img
            className="cursor-pointer"
            style={{ marginLeft: "-6px" }}
            src={isHoveredAccepted ? GredCheck : GreenCheck}
            alt="back-to-completed"
          />
        </div>
      )}
    </div>
  );
});

export default TodoChangeStatus